import PushNotificationsPanel from "../components/notifications/PushNotificationsPanel.jsx";
import { hasPermission, useMyPermissions } from "../lib/permissions.js";
import { PERMISSIONS } from "../lib/permissionKeys.js";

// Alert destinations, in Settings: where the organization's findings are sent.
export default function NotificationsPage() {
    // Delete alone needs `manage`; `manage` implies `write` but not the
    // reverse, so a custom role can hold write without it. The section's
    // gate already required write to get here.
    const caps = useMyPermissions();
    const canManage = hasPermission(caps, PERMISSIONS.INTEGRATIONS_MANAGE);
    return <PushNotificationsPanel canManage={canManage} />;
}
